export default function getImageSrc(imageUrl: string | null) {
  if (imageUrl) {
    return imageUrl;
  } else {
    return '/next/assets/images/coming-soon-image.png';
  }
}
